import { InferGetServerSidePropsType } from 'next'
import { useRouter } from 'next/router'
import { ReactElement } from 'react'
import { WebStep01IndexPage } from '../../components/pages/web/01-index/WebStep01IndexPage'
import WebLayout from '../../components/pages/web/WebLayout'
import { getWebServerSideProps } from '../../server/utils/web/getWebServerSideProps'
import { NextPageWithLayout } from '../_app'

const Page: NextPageWithLayout<InferGetServerSidePropsType<typeof getServerSideProps>> = (props) => {
  const router = useRouter()
  const onNextButtonClick = () => router.push(props.nextPage)

  return <WebStep01IndexPage onNextButtonClick={onNextButtonClick} quotes={props.quotes} />
}

Page.getLayout = function getLayout(page: ReactElement) {
  return <WebLayout>{page}</WebLayout>
}

export default Page

export const getServerSideProps = getWebServerSideProps
